import { z } from 'zod';

const envSchema = z.object({
  VITE_API_URL: z.string().url(),
  VITE_SUPABASE_URL: z.string().url(),
  VITE_SUPABASE_ANON_KEY: z.string().min(1, 'VITE_SUPABASE_ANON_KEY obrigatório'),
  VITE_SENTRY_DSN: z.string().optional().default(''),
  VITE_SENTRY_ENVIRONMENT: z.string().default('development'),
});

const parsed = envSchema.safeParse(import.meta.env);

if (!parsed.success) {
  // eslint-disable-next-line no-console
  console.error('Variáveis de ambiente inválidas:', parsed.error.flatten().fieldErrors);
  throw new Error('Falha ao carregar variáveis de ambiente do frontend.');
}

export const env = parsed.data;
export type Env = typeof env;
